import * as actionTypes from './types/configurationsActionTypes';

export function getConfigurationSucceed(data) {
    return {
        type: actionTypes.GET_CONFIGURATION_SUCCEED,
        data,
    };
}
